import React from "react";

import { CreateModal } from "@components/Page";
import { MODAL_WIDTH2 } from "@components/Constants";
import { useAppContext } from "@components/AppContext";
import { type AppContext } from "@components/AppContext/types";
import { createMyPersonalAccessTokenOperation as operation } from "@api/services/identity";
import { type CreatedPersonalAccessToken } from "@api/types";

import getCreateInputs from "./helpers/getCreateInputs";

const LABEL_TITLE = "Create Personal Access Token";
const LABEL_SUBMIT = "Create";
const LABEL_ENTITY = "Personal Access Token";

export type PersonalAccessTokenCreateModalHandle = {
  open: () => void;
};

type Props = {
  modal: React.RefObject<
    PersonalAccessTokenCreateModalHandle | Record<string, never>
  >;
  onSuccess: (createdToken: CreatedPersonalAccessToken) => void;
};

const PersonalAccessTokenCreateModal = ({
  modal,
  onSuccess,
}: Props): JSX.Element => {
  // NOTE: personal access tokens are owned by the identity rather than by
  //       the organization membership, so every operation is authenticated
  //       with the authentication token instead of the authorization one.
  const { authenticatedRequest } = useAppContext() as AppContext;

  const inputs = getCreateInputs();
  const schema = operation.getSchema(inputs);

  const createModalProps = {
    title: LABEL_TITLE,
    entity: LABEL_ENTITY,
    submitLabel: LABEL_SUBMIT,
    request: authenticatedRequest,
    width: MODAL_WIDTH2,
    modal,
    schema,
    onSuccess,
    operation,
  };

  return (
    <CreateModal {...createModalProps} />
  );
};

export default PersonalAccessTokenCreateModal;
